<template>
  <v-container class="px-0 py-0" fluid>
    <v-row dense>
      <v-col>
        <InspAttachmentForm />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import InspAttachmentForm from '@/components/organisms/master/form/InspAttachmentForm'

export default {
  name: 'InspectionAttachmentPage',
  components: {
    InspAttachmentForm,
  },
}
</script>
